import * as Scrivito from "scrivito";

import { DefaultLayout } from "./DefaultLayout";

Scrivito.provideComponent(
  "CourseDetailsWidget",
  Scrivito.connect(({ widget }) => {
    const obj = widget.get("course") || Scrivito.currentPage();
    let course = obj.get("course") ? obj.get("course") : null;
    if (!course && obj.objClass() === "CoursePage") {
      course = obj;
    }

    if (!course) {
      return (
        <div className="alert alert-warning">
          No Course is selected. Look at the details of this widget to set one.
        </div>
      );
    }

    return <DefaultLayout obj={obj} course={course} widget={widget} />;
  })
);
